var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlusRoundedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.975,
    height: 18.975
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31540",
    d: "M9.488 18.974a9.087 9.087 0 003.662-.747 9.721 9.721 0 003.031-2.055 9.668 9.668 0 002.051-3.02 9.128 9.128 0 00.742-3.67 9.087 9.087 0 00-.747-3.662 9.78 9.78 0 00-2.056-3.032A9.543 9.543 0 0013.144.737 9.19 9.19 0 009.482 0a9.155 9.155 0 00-3.657.737 9.617 9.617 0 00-3.027 2.051A9.669 9.669 0 00.742 5.82 9.138 9.138 0 000 9.482a9.076 9.076 0 00.747 3.67 9.737 9.737 0 002.055 3.02 9.737 9.737 0 003.023 2.055 9.076 9.076 0 003.663.747zM4.97 9.492a.846.846 0 01.244-.625.846.846 0 01.625-.244h2.793V5.84a.865.865 0 01.234-.625.8.8 0 01.605-.244.852.852 0 01.63.239.852.852 0 01.239.63v2.783h2.8a.83.83 0 01.62.244.856.856 0 01.239.625.818.818 0 01-.244.61.843.843 0 01-.615.239h-2.799v2.793a.843.843 0 01-.239.618.842.842 0 01-.63.244.8.8 0 01-.605-.244.853.853 0 01-.234-.615v-2.796H5.839a.856.856 0 01-.625-.239.818.818 0 01-.244-.61z",
    fill: "#fff"
  })));
}

export default SvgPlusRoundedIcon;